import React from "react";
import ImgLogo from "../../public/assets/main-logo.svg";
// import { NavLink } from "react-router-dom";
import Link from "next/link";
import Image from "next/image";

export default function MainLogo({ fill }) {
  return (
    <div className="MainLogo">
      <Link href="/" aria-label="Logo eternal slots">
        {/* <img src={ImgLogo} className="" alt="goat spins" /> */}
        {/* <svg className="st0" stroke={stroke} width="400" height="400">
          <circle cx="100" cy="100" r="50" stroke-width="5" />
        </svg> */}

        {/* SVG LOGO */}
        {/* <svg>
          <g>
            <path
              className="st0"
              d="M69.1,28.6c3.6,0,6.4,2.9,6.4,6.4c0,3.6-2.9,6.4-6.4,6.4s-6.4-2.9-6.4-6.4C62.7,31.4,65.6,28.6,69.1,28.6
		 M69.1,22.3c-7,0-12.7,5.7-12.7,12.7c0,7,5.7,12.7,12.7,12.7c7,0,12.7-5.7,12.7-12.7C81.8,28,76.1,22.3,69.1,22.3L69.1,22.3z"
            />
            <g>
              <g>
                <path
                  className="st0"
                  d="M40.1,23c0.2,0.3,0.3,0.6,0.3,0.8c0,0.2,0,0.6,0,1.1v16.7c0,1.4-0.4,2.2-1.1,2.4c-0.4,0.1-0.9,0.2-1.4,0.2
				c-0.6,0-1,0-1.4-0.2c-0.3-0.1-0.6-0.2-0.8-0.4c-0.2-0.1-0.3-0.3-0.4-0.6c-0.1-0.3-0.2-0.9-0.2-1.6V31.4c-0.5,0.6-1.2,1.6-2.2,3
				c-1,1.4-1.6,2.2-1.8,2.5c-0.3,0.3-0.4,0.6-0.5,0.7c-0.1,0.1-0.3,0.3-0.7,0.5c-0.4,0.2-0.8,0.3-1.3,0.3c-0.5,0-0.9-0.1-1.2-0.3
				c-0.4-0.2-0.6-0.4-0.8-0.6l-0.2-0.3c-0.4-0.5-1.2-1.6-2.4-3.2c-1.2-1.6-1.8-2.5-1.9-2.6v10.1c0,0.5,0,0.8,0,1
				c0,0.2-0.1,0.5-0.3,0.8c-0.3,0.5-1.1,0.8-2.3,0.8c-1.2,0-2-0.3-2.3-0.8c-0.2-0.3-0.3-0.5-0.3-0.8c0-0.2,0-0.6,0-1.1V24.8
				c0-0.5,0-0.8,0-1c0-0.2,0.1-0.5,0.3-0.8c0.3-0.5,1.1-0.8,2.3-0.8c0.5,0,1,0.1,1.4,0.2c0.4,0.1,0.6,0.3,0.8,0.4l0.2,0.2l6.8,9
				c3.4-4.5,5.7-7.5,6.8-8.9c0.3-0.5,1.1-0.8,2.4-0.8C39.1,22.2,39.8,22.5,40.1,23z"
                />
              </g>
              <g>
                <path
                  className="st0"
                  d="M53.6,28.5c0.4,0.1,0.7,0.3,0.9,0.6c0.3,0.3,0.4,0.8,0.4,1.4c0,0.6-0.2,1.3-0.6,2.1
				c-0.4,0.8-0.9,1.1-1.7,1.1c-0.4,0-0.7-0.1-1-0.2c-0.3-0.2-0.8-0.2-1.3-0.2c-0.5,0-1,0.2-1.5,0.6c-0.5,0.4-0.7,0.8-0.7,1.4v6.3
				c0,0.5,0,0.8,0,1c0,0.2-0.1,0.5-0.3,0.8c-0.3,0.5-1.1,0.8-2.3,0.8c-1,0-1.7-0.2-2.1-0.5c-0.3-0.3-0.5-0.7-0.5-1.3
				c0-0.2,0-0.5,0-0.9V31c0-0.5,0-0.8,0-1c0-0.2,0.1-0.5,0.3-0.8c0.3-0.5,1.1-0.8,2.3-0.8c1.2,0,2,0.2,2.3,0.7
				c0.2,0.3,0.3,0.7,0.3,1c0.1-0.1,0.2-0.3,0.4-0.5c0.2-0.2,0.6-0.5,1.2-0.8c0.6-0.3,1.2-0.5,1.6-0.5c0.5,0,0.9,0,1.2,0.1
				C52.9,28.3,53.3,28.4,53.6,28.5z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  className="st1"
                  d="M68.9,59.4c-7.3,0-14.2-3.3-18.8-8.9c-1.1-1.4-0.9-3.4,0.5-4.6c1.4-1.1,3.4-0.9,4.6,0.5
				c3.4,4.2,8.5,6.5,13.8,6.5c9.9,0,17.9-8,17.9-17.9s-8-17.9-17.9-17.9c-5.4,0-10.4,2.4-13.8,6.5c-1.1,1.4-3.2,1.6-4.6,0.5
				c-1.4-1.1-1.6-3.2-0.5-4.6c4.7-5.7,11.5-8.9,18.8-8.9c13.4,0,24.4,10.9,24.4,24.4S82.4,59.4,68.9,59.4z"
                />
              </g>
            </g>
          </g>
        </svg> */}
        <Image
          src={ImgLogo.src}
          alt="goat spins"
          width={200}
          height={30}
          priority
        />
        {/* SVG LOGO */}
      </Link>
    </div>
  );
}
